<template>
  <div>
    <vs-card class="mt-6 mb-base">
      <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="prod">

        <template slot="header">
          <div class="vx-col sm:w-1/2 w-full">
            <img :src="require('@/assets/images/icons/icon_folder_b.png')" style="position: absolute;margin-left: 20px;" />
            <h3 style="margin-left: 55px;">Staging PRD Forms</h3>
          </div>

          <!-- ITEMS PER PAGE -->

          <div class="vx-col sm:w-1/4 w-full flex justify-between">
            <!--            <vs-button @click="activePrompt=true">Export</vs-button>-->
            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer items-per-page-handler">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ prod.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : prod.length }} of {{ queriedItems }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </template>

        <template slot="thead">
          <vs-th sort-key="MESSAGEID">Message</vs-th>
          <vs-th sort-key="PRODID">Production ID</vs-th>
          <vs-th sort-key="ITEMID">Item</vs-th>
          <vs-th sort-key="DLVDATE">Delivery Date</vs-th>
          <vs-th sort-key="QTY">Quantity</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td>
              <router-link :to="'/staging/form/'+tr.MESSAGEID">
                <p class="product-name font-medium text-center"><b>{{ tr.MESSAGEID }}</b></p>
              </router-link>
              <p class="product-category text-center" v-if="tr.message">{{ tr.message.MESSAGETYPE }}</p>
            </vs-td>
            <vs-td>
<!--              <router-link :to="'/staging/form/'+tr.PRODID">-->
                <p class="product-name font-medium text-center"><b>{{ tr.PRODID }}</b></p>
<!--              </router-link>-->
              <vs-chip transparent color="primary" v-if="tr.center">{{ tr.center }}</vs-chip>
            </vs-td>
            <vs-td>
              <vs-avatar v-if="tr.center && expandCenter(tr.center)" class="mr-3" style="float:left" size="30px" :src="center_img[expandCenter(tr.center).operation]" />
              <p class="product-name font-medium"><b>{{ tr.ITEMID }}</b></p>
              <p class="product-category">{{ tr.ITEMNAME }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category text-center">{{ moment(tr.DLVDATE).format('DD MMM YYYY') }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category text-center"><b>{{ tr.QTY }} kg</b></p>
            </vs-td>
            <vs-td class="text-center">
              <p class="product-category text-center" v-if="tr.message">
                <vs-chip :color="textAction(tr.message.ACTIONTYPE).color">
                  <vs-avatar icon-pack="feather" icon="icon-send" color />
                  <span>{{ textAction(tr.message.ACTIONTYPE).text }}</span>
                </vs-chip>
              </p>
              <p class="product-category text-center" v-if="tr.message">
                <vs-chip :color="textStatus(tr.message.STATUS).color">
                  <vs-avatar icon-pack="feather" icon="icon-send" color />
                  <span>{{ textStatus(tr.message.STATUS).text }}</span>
                </vs-chip>
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <vs-avatar icon-pack="feather" icon="icon-eye" color="primary" :disabled="true" @click.stop="goTo('/staging/form/'+tr.MESSAGEID)" />
<!--              <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="goTo('/staging/form/'+tr.MESSAGEID)" />-->
<!--              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current ml-2" @click.stop="editData(tr)" />-->
            </vs-td>

          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      selected: [],
      prod: [],
      itemsPerPage: 25,
      isMounted: false,

      centers: [],
      center_img: {
        furnace: require('@/assets/images/center/furnace_300.jpg'),
        press: require('@/assets/images/center/press_300.jpg'),
        roller: require('@/assets/images/center/roller_300.jpg'),
        draw: require('@/assets/images/center/draw_300.jpg'),
        wind: require('@/assets/images/center/wind_300.jpg'),
        spool: require('@/assets/images/center/spool_300.png'),
        pack: require('@/assets/images/center/pack_300.png'),
        flux: require('@/assets/images/center/flux_300.jpg')
      },

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  created () {
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.prod.length
    }
  },
  mounted () {
    this.isMounted = true
    this.fetchMessages()
  },
  methods: {
    fetchMessages () {
      this.$vs.loading()
      this.$http.get('/api/staging/prod?include=center,message')
        .then(({ data }) => {
          this.prod = data.prod
          this.centers = data.centers
          this.message = data.message
          this.$vs.loading.close()
        })
        .catch(e => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Failed to fetch data',
            text: e.response.data.message || e.message,
            iconPack: 'feather',
            icon: 'icon-x',
            color: 'danger',
            timer: 1500
          })
        })
    },
    addNewData () {
      this.sidebarData = {}
      // this.toggleDataSidebar(true)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      // this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    textAction (action) {
      if (action === 'N') return { text:'New', color:'success' }
      else if (action === 'M') return { text:'Modify', color:'warning' }
      else if (action === 'D') return { text:'Delete', color:'danger' }
      else return { text:action, color:'secondary' }
    },
    textStatus (status) {
      if (status === 'N') return { text:'New', color:'success' }
      else if (status === 'R') return { text:'Ready', color:'primary' }
      else if (status === 'P') return { text:'Process', color:'warning' }
      else if (status === 'E') return { text:'Error', color:'danger' }
      else return { text:status, color:'secondary' }
    },
    goTo (path) {
      this.$router.push({ path })
    },
    expandCenter (center) {
      let fixedCenter = center
      if (center.length < 4 && center[0] === 'L') fixedCenter = 'DRAW-' + String(fixedCenter.replace(/^\D+/g, '')).padStart(2, '0')

      return this.centers.find(c => c.center === fixedCenter)
    },
    moment (time) {
      return moment(time)
    }
  }
}
</script>

<style>
.vs-card--content {
  padding: 0px;
}
.vs-table--search {
  padding-right: 20px !important;
}
</style>
